import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCSRFToken, clearCSRFToken } from '../utils/csrf';

const CSRFContext = createContext();

export const useCSRF = () => {
  const context = useContext(CSRFContext);
  if (!context) {
    throw new Error('useCSRF must be used within a CSRFProvider');
  }
  return context;
};

export const CSRFProvider = ({ children }) => {
  const [csrfToken, setCsrfToken] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  const initializeCSRF = async () => {
    try {
      setIsLoading(true);
      setError(null);
      const token = await getCSRFToken();
      setCsrfToken(token);
    } catch (err) {
      console.error('Failed to initialize CSRF token:', err);
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  const refreshCSRFToken = async () => {
    try {
      setError(null);
      const token = await getCSRFToken();
      setCsrfToken(token);
    } catch (err) {
      console.error('Failed to refresh CSRF token:', err);
      setError(err.message);
    }
  };

  const clearToken = () => {
    clearCSRFToken();
    setCsrfToken(null);
  };

  useEffect(() => {
    initializeCSRF();
  }, []);

  const value = {
    csrfToken,
    isLoading,
    error,
    refreshCSRFToken,
    clearToken,
  };

  return (
    <CSRFContext.Provider value={value}>
      {children}
    </CSRFContext.Provider>
  );
};
